import * as types from "../actions/actionTypes";
import {IAction} from "../interfaces/actions";

interface StreamChannelReducer {
    state: string,
    errorMessage: string,
    data: any[],
    selectedObject: object
}

const defaultState = {
    data: [],
    state: "success",
    errorMessage: "",
    selectedObject: {}
};

const streamChannelReducer = (state : StreamChannelReducer = defaultState, action: IAction) => {
    switch (action.type) {
        case types.SET_CHANNELS_CURRENT_STATE:
            return {...state, state: action.data};
        case types.SET_CHANNELS_ERROR:
            return {...state, errorMessage: action.data, data: [], state: "error"};
        case types.SET_CHANNELS_SELECTED_OBJECT:
            return {...state, selectedObject : action.data};
        case types.SET_CHANNELS:
            return Object.assign({}, state, {
                data: action.data,
                state: "success"
            });
        default:
            return state;
    }
};

export default streamChannelReducer;
